import React from 'react';
import logo from "../assets/logo.png"
const Navbar = () => {
  return (
    <header className="navbar-fixed">
      <nav className="navbar container">
        <div className="logo">
        <img src={logo} alt="Le-Ma Systems Logo" style={{ height: '40px' }} />
        {/* <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.1 }}>
          <span style={{ fontWeight: 700, fontSize: '1.2rem', letterSpacing: '1px' }}>LE-MA</span>
          <span style={{ fontWeight: 300, fontSize: '0.65rem', letterSpacing: '2px', color: 'var(--color-text-muted)' }}>SYSTEMS</span>
        </div> */}
      </div>

      <div className="nav-links">
        <a href="#home" className="active">Home</a>
        <a href="#services">Services</a>
        <a href="#process">Process</a>
        <a href="#leadership">Leadership</a>
        <a href="#about">About</a>
      </div>

      <div className="country-selector">
        {/* <div className="country">
          <span style={{ fontSize: '1.2rem' }}>🇧🇼</span> Botswana
        </div>
        <div className="country" style={{ cursor: 'pointer', opacity: 0.8 }}>
          <span style={{ fontSize: '1.2rem' }}>🇿🇦</span> South Africa <KeyboardArrowDownIcon fontSize="small" />
        </div> */}
      </div>
      </nav>
    </header>
  );
};

export default Navbar;
